module.exports = __webpack_public_path__ + "img/shield_check_icon.fe3f3915.svg";